/* Article-only player. No media source is attached before a deliberate play. */
(function () {
  'use strict';
  function init(root) {
    if (root.dataset.ready) return;
    var player = root.querySelector('[data-dd-ap-player]');
    var thumbs = Array.from(root.querySelectorAll('[data-dd-ap-src]'));
    var play = root.querySelector('[data-dd-ap-play]');
    var title = root.querySelector('[data-dd-ap-title]');
    var caption = root.querySelector('[data-dd-ap-caption]');
    var count = root.querySelector('[data-dd-ap-count]');
    var rail = root.querySelector('.dd-ap__rail');
    var stage = root.querySelector('.dd-ap__stage');
    if (!player || !thumbs.length || !play || !stage) return;
    root.dataset.ready = 'true';
    var current = 0;
    var visible = false;
    function isVisible() {
      var r = stage.getBoundingClientRect();
      return r.bottom > 0 && r.top < window.innerHeight && !document.hidden;
    }
    function stopped() {
      root.classList.remove('is-playing');
      play.hidden = false;
    }
    function pause() {
      player.pause();
      stopped();
    }
    function start() {
      var thumb = thumbs[current];
      var src = thumb.dataset.ddApSrc;
      if (!src) return;
      if (player.getAttribute('src') !== src) {
        player.src = src;
        player.load();
      }
      player.controls = true;
      var attempt = player.play();
      if (attempt && attempt.catch) attempt.catch(stopped);
    }
    function select(index, shouldPlay) {
      pause();
      current = (index + thumbs.length) % thumbs.length;
      var thumb = thumbs[current];
      thumbs.forEach(function (item, i) {
        if (i === current) item.setAttribute('aria-current', 'true');
        else item.removeAttribute('aria-current');
      });
      player.poster = thumb.dataset.ddApPoster || '';
      title.textContent = thumb.dataset.ddApTitle || '';
      caption.textContent = thumb.dataset.ddApCaption || '';
      count.textContent = String(current + 1).padStart(2, '0') + ' / ' + String(thumbs.length).padStart(2, '0');
      play.setAttribute('aria-label', root.dataset.playLabel + ': ' + title.textContent);
      if (shouldPlay) {
        // Scroll only the rail, never the page. Works with either text direction.
        var r = thumb.getBoundingClientRect();
        var parent = rail.getBoundingClientRect();
        rail.scrollBy({left: r.left + r.width / 2 - parent.left - parent.width / 2, behavior: 'auto'});
        start();
      }
    }
    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener('click', function () { select(index, true); });
    });
    root.querySelector('[data-dd-ap-prev]').addEventListener('click', function () { select(current - 1, true); });
    root.querySelector('[data-dd-ap-next]').addEventListener('click', function () { select(current + 1, true); });
    play.addEventListener('click', start);
    player.addEventListener('click', function (event) {
      // Leave the native timeline, volume and fullscreen controls to the browser.
      var rect = player.getBoundingClientRect();
      if (player.controls && event.clientY > rect.bottom - 52) return;
      event.preventDefault();
      if (player.paused) start();
      else pause();
    });
    player.addEventListener('play', function () {
      document.querySelectorAll('[data-dd-article-opinions] video').forEach(function (other) {
        if (other !== player) other.pause();
      });
      root.classList.add('is-playing');
      play.hidden = true;
    });
    player.addEventListener('pause', stopped);
    player.addEventListener('error', stopped);
    player.addEventListener('ended', function () {
      if (isVisible()) select(current + 1, true);
      else pause();
    });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) pause();
    });
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        visible = entries[0].intersectionRatio >= 0.08;
        if (!visible) pause();
      }, {threshold: [0, 0.08]});
      observer.observe(stage);
    } else {
      window.addEventListener('scroll', function () { if (!isVisible()) pause(); }, {passive: true});
    }
    select(0, false);
  }
  function initAll() { document.querySelectorAll('[data-dd-article-opinions]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
